<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Payment page'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded && payment) {

      <!-- Invoice -->
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [title]="payment.description" [translate]="false" />
          @if (!paid) {
            <tidy-text [body]="'Due ' + (payment.due_date | date:'MMM d')" [translate]="false" />
          }
          @if (paid) {
            <tidy-text [body]="'Paid'" [ngStyle]="{ color: 'var(--primary-button, #4295a3)' }" />
          }
        </tidy-row>
        <div style="position: absolute; left: 0; right: 0; height: 7px; background: #275C7C;"></div>

        @if (!paid) {
          <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
            <tidy-text [body]="'Charge'" />
            <tidy-text [body]="'Amount'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <div style="width: 85%">
              <tidy-text [header]="payment.description" [translate]="false" />
            </div>
            <div>
              <tidy-text [body]="'$' + payment.amount.toLocaleString('en-US')" [translate]="false" />
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="payment.property_name + ' · ' + payment.unit" [translate]="false" />
          </tidy-row>
          @if (selectedFeeLabel) {
            <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
              <tidy-text [body]="'Processing fee'" />
              <tidy-text [body]="selectedFeeLabel" [translate]="false" />
            </tidy-row>
          }
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [header]="'Total'" />
            <tidy-text [body]="('<b>$' | translate) + selectedTotalLabel + '</b>'" [translate]="false" />
          </tidy-row>

          <!-- Method picker -->
          <tidy-row class="extra-top-padding"><tidy-text [body]="'Choose how to pay'" /></tidy-row>
          @for (view of methodViews; track view.key) {
            <div
              (click)="selectMethod(view.key)"
              [ngStyle]="{
                'border': (selectedKey === view.key ? '2px' : '1px') + ' solid ' + (selectedKey === view.key ? 'var(--primary-button, #4295a3)' : '#e0e0e0'),
                'background': selectedKey === view.key ? 'color-mix(in srgb, var(--primary-button, #4295a3) 10%, transparent)' : 'transparent',
                'border-radius': '8px', 'padding': '10px 12px', 'margin-bottom': '8px', 'cursor': 'pointer',
                'display': 'flex', 'align-items': 'center', 'justify-content': 'space-between'
              }">
              <div [ngStyle]="{ 'display': 'flex', 'align-items': 'center' }">
                <span [ngStyle]="{
                  'width': '16px', 'height': '16px', 'border-radius': '50%', 'margin-right': '10px', 'flex-shrink': '0',
                  'border': '2px solid ' + (selectedKey === view.key ? 'var(--primary-button, #4295a3)' : '#bdbdbd'),
                  'background': selectedKey === view.key ? 'var(--primary-button, #4295a3)' : 'transparent'
                }"></span>
                <div>
                  <div><tidy-text [body]="view.label" [translate]="false" /></div>
                  <div><tidy-text [helper]="view.subLabel" [translate]="false" /></div>
                </div>
              </div>
              <tidy-text [body]="('<b>$' | translate) + view.totalLabel + '</b>'" [translate]="false" />
            </div>
          }
        }

        @if (paid) {
          <tidy-row class="extra-top-padding vertical-align-center">
            <div [ngStyle]="{ 'width': '44px', 'height': '44px', 'border-radius': '50%', 'background': 'var(--primary-button, #4295a3)', 'margin-right': '12px', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center' }">
              <tidy-image [src]="'assets/svg/checkmark-outline.svg'" style="filter: brightness(0) invert(1);" class="title-size" />
            </div>
            <tidy-text [header]="'Payment received'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'Thanks! Your ' + ('$' + payment.amount.toLocaleString('en-US')) + ' payment for ' + payment.description + ' is confirmed. A receipt has been emailed to you.'" [translate]="false" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-button [text]="'Done'" [action]="doneAction" class="primary" />
          </tidy-row>
        }
      </tidy-card>

      @if (!paid) {
        <tidy-row>
          <tidy-button
            [text]="('Pay $' | translate) + selectedTotalLabel"
            [action]="payAction"
            class="primary" />
        </tidy-row>
        <tidy-row [align]="'center'">
          <tidy-text [helper]="'Payments are encrypted and processed securely. Powered by TIDY.'" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
